//
import Model from '@/models/Model'

/**
 * This class describes a pch detail purchase order edited.
 *
 * @class      PchDetailPurchaseOrderEdited (name)
 */
export default class PchDetailPurchaseOrderEdited extends Model {

    /**
     *
     */
    get wh_product_internal_code() {
        return this.wh_product ? this.wh_product.internal_code : '-'
    }

    /**
     *
     */
    get wh_product_name() {
        return this.wh_product ? this.wh_product.name : '-'
    }

    /**
     *
     */
    get wh_product_service_name() {
        return this.wh_product_service ? this.wh_product_service.name : '-'
    }

    /**
     * @description
     */
    resource() {
        return 'pch_detail_purchase_order_edited'
    }
}
